function getCSSVariableValue(variableName: string) {
	try {
		const element = document.documentElement // or any specific element
		const computedStyle = getComputedStyle(element)
		return computedStyle.getPropertyValue(variableName).trim()
	} catch (error) {
		console.error(`Error getting CSS variable value for ${variableName}:`, error)
		return ''
	}
}

export function getComputedColors() {
	return {
		neutral950: getCSSVariableValue('--mui-palette-neutral-950'),
		backgroundPaper: getCSSVariableValue('--mui-palette-background-paper'),
		textPrimary: getCSSVariableValue('--mui-palette-text-primary'),
		textSecondary: getCSSVariableValue('--mui-palette-text-secondary'),
		neutral400: getCSSVariableValue('--mui-palette-neutral-400'),
		neutral700: getCSSVariableValue('--mui-palette-neutral-700'),
		neutral900: getCSSVariableValue('--mui-palette-neutral-900'),
	}
}
